import type { EarlyLoanRepaymentFeatureConfig } from '../../../types/features/EarlyLoanRepaymentFeatureConfig';

export const earlyLoanRepayment: EarlyLoanRepaymentFeatureConfig = {
    preloadRepaymentOptions: true,
    isFullRepaymentPossible: false,
    summary: {
        showSubtitle: false,
        showSubtitleWhatPointsToElectronicStorage: true,
        showExtraordinaryRepaymentMessage: false,
        showLoanNumber: true,
        showPaidFromAccount: true,
        showCurrentInstalment: true,
        showFaqSection: false,
        showDocumentDownload: true,
        showFees: false,
        showSimplifiedFees: true,
        showCurrentMaturityDate: true,
        showNextMaturityDate: true,
        showNextInstallmentDateFromAccountResponse: false,
        showNextInstallmentDateFromRepaymentInfoResponse: true,
        showNextInstallmentAmount: false,
        showNewInstallmentAmount: true,
        showRemainingInstallmentsBeforeReimbursement: false,
        showRemainingInstallmentsAfterReimbursement: false,
        showShortenedInstallments: false,
        showInstallmentFrequency: false,
        showRemainingInstallments: false,
        showCurrentDueDate: false,
        showNewDueDate: false,
        showCurrentLoanBalance: false,
        showNewLoanBalance: false,
        showPaidInterest: false,
    },
    amountInput: {
        showFeesMessage: false,
        showPossibleAmountRangeInfo: true,
    },
    inputValidation: {
        overTheMaximumKey: 'products.loanRepayment.maximumAmountTextTotalRepayment',
    },
    errorScreen: {
        showPhoneSupportError: false,
        showAMLSuspectError: false,
        conditionNotMetKey: 'products.statements.conditionsNotMet',
        amlSuspectKey: '',
    },
    adjustLoan: {
        showTooShortPeriodMessage: true,
        showInfoMessageAboutSpecificLoanRepayment: false,
        showInfoMessageAboutHigherPayment: true,
    },
};
